import React from 'react';

export default class ClearanceNoMatchCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: false
        };
    }

    /**
     * When user changes value of the checkbox
     */
    onChange() {
        this.setState({ isActive: !this.state.isActive });
    }

    render() {
        const { onSubmit, onCancel } = this.props;

        return (
            <div className="row mb-x2">
                <div className="col-xs-12">
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            onSubmit();
                        }}
                    >
                        <h4>No matches?</h4>
                        <div className="checkbox">
                            <label style={{ lineHeight: 1.6, fontSize: '1.2em' }}>
                                <input type="checkbox" onChange={this.onChange.bind(this)} /> The
                                above don't match my project
                            </label>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-default mt"
                            disabled={!this.state.isActive}
                        >
                            Continue
                        </button>
                        <button type="button" className="btn btn-link mt" onClick={onCancel}>
                            Re-enter Clearance Information
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}
